export default class PreviewHandler {

    constructor(previewUrl) {
        this.vue = window.AppKit.getApp();
        this.previewUrl = previewUrl;
    }

    /**
     * Get the skin settings preview url
     * @param metadataId
     * @param blueprintId
     * @returns {string}
     */
    getPreviewUrl(verticalId, bluerpintId) {
        const url = new URL(this.previewUrl);
        url.searchParams.append('verticalId', verticalId);
        url.searchParams.append('blueprintId', bluerpintId);

        return url.toString();
    }
}